import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { UpdateHospitalityMenuCategoryItemMetaForm } from "./UpdateHospitalityMenuCategoryItemMetaForm";
import { HospitalityMenuCategory, HospitalityMenuCategoryItem } from "@/lib/types";
import { EditIcon } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { UpdateHospitalityMenuCategoryItemMetaFormImage } from "./UpdateHospitalityMenuCategoryItemMetaFormImage";
import { Separator } from "@/components/ui/separator";
import { UpdateHospitalityMenuCategoryItemAllergies } from "./UpdateHospitalityMenuCategoryItemAllergies";

interface Props {
  category: HospitalityMenuCategory;
  categoryItem: HospitalityMenuCategoryItem;
}

export const UpdateHospitalityMenuCategoryItemDialog: React.FC<Props> = ({ category, categoryItem }) => {
  const { t } = useTranslation();
  const [open, onOpenChange] = useState(false);

  const queryClient = useQueryClient();

  return (
    <Dialog
      open={open}
      onOpenChange={(newOpen) => {
        onOpenChange(newOpen);

        // If the dialog is closed, invalidate the query to get the updated data
        if (!newOpen) {
          queryClient.invalidateQueries({
            queryKey: ["getHospitalityMenuCategoryItem"],
          });
        }
      }}
    >
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <EditIcon className="w-2 h-2" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("common.entityDetail", { name: categoryItem.name })}</DialogTitle>
          <DialogDescription className="overflow-y-auto max-h-[80vh]">
            <UpdateHospitalityMenuCategoryItemMetaFormImage categoryItem={categoryItem} />
            <Separator className="my-4" />
            <UpdateHospitalityMenuCategoryItemMetaForm category={category} categoryItem={categoryItem} />
            <Separator className="my-4" />
            <UpdateHospitalityMenuCategoryItemAllergies categoryItem={categoryItem} />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
